import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import { ProductCard } from "@/components/ProductCard";
import { ImageReveal, Reveal } from "@/components/Reveal";
import { useSeo } from "@/lib/seo";

export function Wishlist() {
  const { t, wishlist } = useStore();
  useSeo({ title: t("wishlist") });
  return (
    <main className="container-x min-h-[60vh] py-16" data-testid="wishlist-page">
      <h1 className="font-display text-6xl font-black uppercase tracking-tighter sm:text-8xl">{t("wishlist")}</h1>
      {wishlist.length === 0 ? (
        <div className="mt-10"><p className="text-ink/60" data-testid="wishlist-empty">{t("wishlistEmpty")}</p><Link to="/shop" className="btn-ink mt-8">{t("shopNow")}</Link></div>
      ) : (
        <div className="mt-12 grid grid-cols-2 gap-x-4 gap-y-10 md:grid-cols-3 lg:grid-cols-4">{wishlist.map((p, i) => <ProductCard key={p.id} p={{ ...p, images: p.images || [] }} index={i} />)}</div>
      )}
    </main>
  );
}

export function Collections() {
  const { t } = useStore();
  const [cols, setCols] = useState([]);
  useSeo({ title: t("collections"), description: "Shop every CASABLANCA collection: Nike, Air Jordan, Adidas, New Balance, Puma, Asics and more." });
  useEffect(() => { api.get("/collections").then((r) => setCols(r.data)); }, []);
  return (
    <main className="pb-24" data-testid="collections-page">
      <div className="container-x pb-14 pt-16">
        <Reveal><h1 className="font-display text-6xl font-black uppercase leading-[0.85] tracking-tighter sm:text-9xl">{t("collections")}</h1></Reveal>
      </div>
      <div className="container-x grid gap-3 sm:grid-cols-2">
        {cols.map((c, i) => (
          <Link key={c.slug} to={`/collections/${c.slug}`} className="group relative block h-[56vh] overflow-hidden bg-concrete" data-testid={`collections-page-card-${c.slug}`}>
            <ImageReveal src={c.image} alt={c.title} className="absolute inset-0 transition-transform duration-[1.4s] ease-out group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/80 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-8 text-sun">
              <div><p className="font-mono text-[10px] uppercase tracking-[0.3em] text-sun/60">{String(i + 1).padStart(2, "0")} · {c.count} {t("products")}</p>
                <h2 className="mt-2 font-display text-5xl font-black uppercase tracking-tight sm:text-6xl">{c.title}</h2></div>
              <ArrowUpRight className="h-8 w-8 transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1" />
            </div>
          </Link>
        ))}
      </div>
    </main>
  );
}

export function NotFound() {
  return (
    <main className="container-x py-32" data-testid="not-found-page">
      <p className="eyebrow text-ink/50">404</p>
      <h1 className="mt-4 font-display text-7xl font-black uppercase">Lost the trail.</h1>
      <Link to="/" className="btn-ink mt-10">Home</Link>
    </main>
  );
}
